<template>
  <div class="mod-rela__courseChoice">
    <div style="margin-top: 5px;">
      <el-row :gutter="10">
        <el-col :span="18">
          <el-card shadow="never"
                   class="aui-card--fill">
            <el-form label-position="left"
                     @keyup.enter.native="queryCourse()"
                     label-width="auto"
                     class="curriculum-search-condition"
                     :model="dataForm">
              <el-row class="margb10">
                <!--场地名称-->
                <el-col :span="7">
                  <el-form-item class="search-item">
                  <span slot="label">
                  <el-link type="primary"
                         :underline="false"
                         slot="reference">{{ $t('offering.location') }}</el-link>
                    </span>
                    <el-input v-model="dataForm.location"
                              placeholder="请选择"
                              disabled></el-input>
                  </el-form-item>
                </el-col>
                <!--课程代码-->
                <el-col :span="7">
                  <el-form-item prop="courseCode"
                                class="search-item">
                    <span slot="label">
                <el-link type="primary"
                         :underline="false"
                         @click="showCourseDlg">选择课程</el-link>
              </span>
                    <el-input v-model="courseName"
                              disabled
                              placeholder="请选择"></el-input>
                  </el-form-item>
                  <el-dialog :modal="false"
                             width="80%"
                             :visible.sync="dialogTableVisibles">
                    <div style="height: 600px;">
                      <offeringCoursedlist ref="offeringCoursedlist"
                                           @offeringcodeadd="offeringcodeadd"
                                           @offeringcodelist="offeringcodelist"
                                           @selectCodeClose="selectCodeClose">
                      </offeringCoursedlist>
                    </div>
                  </el-dialog>
                </el-col>
                <!--排期编号-->
                <el-col :span="7">
                  <!-- 排期编号 offeringNo -->
                  <el-form-item :label="$t('offering.offeringNo')"
                                class="search-item">
                    <el-input v-model="dataForm.offeringNo"
                              clearable
                              :placeholder="$t('course.plsin')"></el-input>
                  </el-form-item>
                </el-col>
                <!--查询-->
                <el-col :span="3">
                  <el-button type="primary"
                             @click="queryCourse()">{{ $t('query') }}</el-button>
                </el-col>
              </el-row>
              <el-row class="margb10">
                <!-- 开始时间 -->
                <el-col :span="10">
                  <el-form-item :label="$t('offering.startdate')"
                                class="search-item"
                                style="width: 100%!important;">
                    <el-date-picker style="width:100%"
                                    v-model="startdateRange"
                                    type="daterange"
                                    format="yyyy-MM-dd"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  &nbsp;
                </el-col>
                <el-col :span="10">
                  <!-- 结束时间  -->
                  <el-form-item :label="$t('offering.enddate')"
                                class="search-item"
                                style="width: 96%!important;">
                    <el-date-picker style="width:100%"
                                    v-model="enddateRange"
                                    type="daterange"
                                    format="yyyy-MM-dd"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <!--重置-->
                <el-col :span="3">
                  <el-button class="el-back" type="info" @click="init()">{{$t('reset')}}</el-button>
                </el-col>
              </el-row>
              <el-row class="btnAdvancedSearch">

              </el-row>
            </el-form>
            <el-table v-loading="dataListLoading"
                      :data="dataList"
                      border
                      @select="selectRedio"
                      @selection-change="selectionChange"
                      @sort-change="dataListSortChangeHandle"
                      style="width: 100%;"
                      class="jySelectionAll"
                      ref="coursePlanTable">
              <el-table-column type="selection"
                               header-align="center"
                               align="center"
                               width="50"></el-table-column>
              <!--排期ID-->
              <el-table-column prop="offeringId"
                               header-align="center"
                               v-if="false"
                               align="center"
                               :label="$t('res.vehinfo.id')">
              </el-table-column>
              <!--排期编号-->
              <el-table-column prop="offeringNo"
                               :label="$t('vehicleAllocation.offeringNo')"
                               header-align="center"
                               align="center"
                               show-overflow-tooltip></el-table-column>
              <!-- 课程编号 -->
              <el-table-column prop="courseCode"
                               :label="$t('vehicleAllocation.courseCode')"
                               header-align="center"
                               align="center"
                               show-overflow-tooltip></el-table-column>
              <!--课程名称-->
              <el-table-column prop="courseNameCn"
                               :label="$t('vehicleAllocation.courseNameCn')"
                               header-align="center"
                               align="left"
                               show-overflow-tooltip></el-table-column>
              <!--课程分类-->
              <!--排期状态-->
              <el-table-column prop="offeringStatus"
                               :label="$t('offering.offringstatus')"
                               header-align="center"
                               align="center"
                               :formatter="demandformat"
                               show-overflow-tooltip></el-table-column>
              <!--开始时间-->
              <el-table-column prop="startdate"
                               :label="$t('vehicleAllocation.offeringDateS')"
                               header-align="center"
                               show-overflow-tooltip
                               align="center"></el-table-column>
              <!--结束时间-->
              <el-table-column prop="enddate"
                               :label="$t('vehicleAllocation.offeringDateE')"
                               header-align="center"
                               show-overflow-tooltip
                               align="center"></el-table-column>
            </el-table>
            <el-pagination :current-page="page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="limit"
                           :total="total"
                           layout="total, sizes, prev, pager, next, jumper"
                           @size-change="pageSizeChangeHandle"
                           @current-change="pageCurrentChangeHandle">
            </el-pagination>
          </el-card>
        </el-col>
        <!--已选课程-->
        <el-col :span="6">
          <div style="text-align:right;margin-bottom:15px;">
            <el-button plain
                       @click="cancel"
                       size="mini">{{$t('cancel')}}</el-button>
            <el-button type="primary"
                       @click="onOk"
                       size="mini">{{$t('confirm')}}</el-button>
          </div>
          <el-card class="box-card">
            <div style="text-align:center;">
              <span class="dataBox">{{$t('cert.selectedScheduled')}}</span>
              <div>
                <el-row :gutter="10">
                  <el-col v-for="(tag, index) in courseData"
                          :key="index">
                    <el-tag style="margin-bottom: 10px;width: 95%;"
                            :key="tag.offeringNo"
                            @close="handleClose(tag)"
                            closable>
                      <div style="width:90%;float:left;overflow-x:hidden; overflow-y:hidden; word-break:keep-all; white-space:nowrap;">{{tag.offeringNo}}</div>
                    </el-tag>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <subordinate-site ref="suborSiteRef"
                      :isSingleElection='false'
                      v-bind:selectTable="selectTable"
                      :dialogVisible="isShowSuboSite"
                      v-on:closeSuboSiteDlg="closeSuboSiteDlg"
                      v-on:bringBack="bringBack">
    </subordinate-site>
    <course-multiple ref="refCourseMultiple"
                     :isSingleElection='false'
                     v-bind:selectCourseTable="selectCourseTable"
                     :dialogVisible="isShowCourse"
                     v-on:closeCourseDlg="closeCourseDlg"
                     v-on:resetCourseData="resetCourseData"
                     v-on:courseSelectBack="courseSelectBack">
    </course-multiple>
  </div>
</template>

<script>
  import mixinViewModule from '@/mixins/view-module'
  import courseSelect from '@/components/learning/course-multiple/index'
  import siteSelect from '@/components/rm/subordinate-site/index'
  import offeringCoursedlist from '@/views/modules/learning/offering/offeringcommon/offeringCoursedlist'
  import catalogtree from '@/views/modules/learning/common/catalogtree'
  import Vue from 'vue'
  export default {
    mixins: [mixinViewModule],
    data () {
      return {
        mixinViewModuleOptions: {
          activatedIsNeed: false,
          getDataListURL: '/learning/base/offeringinfo/allocationPage',
          getDataListIsPage: true,
          deleteIsBatch: true
        },
        // 课程分类树
        defaultPropsz: {
          children: 'children',
          label: 'catalogNameCn',
          id: 'catalogId'
        },
        // 开始时间
        startdateRange: [],
        // 结束时间
        enddateRange: [],
        // 最早排期时间
        earliestDate:'',
        // 最晚排期时间
        latestDate:'',
        courseName: '',
        dialogTableVisibles: false,
        selectTable: [],
        selectCourseTable: [],
        isShowCourse: false,
        isShowSuboSite: false,
        showVehicleClassList: [],
        showValue: '',
        queryTreeUrl: '/learning/coursecatalog/list',
        datalist: [],
        courseData: [],
        dataForm: {
          // offeringcoursecode: 'offering',
          // courseStatuslist: '20,30', // 已发布，已下架
          // catalogId: '', // 课程分类
          // courseTeamCatalogId: '', // 课程团队分类
          // courseTeamCatalogFirst: '',
          // courseTeamCatalogSecond: '', // 课程团队分类
          // selectCatalogSecond: '',
          offeringNo: '',
          offeringName: '',
          offringstatus: '',
          catalogId: '', // 课程分类
          courseTeamCatalogFirst: '',
          courseTeamCatalogSecond: '', // 课程团队分类
          courseid: '',
          regionIds: [],
          cityClassList: [],
          courseCode: '',
          courselabel: '', // 课程标签
          startTime: '',
          endTime: '',
          city: '',
          createUserNameEn: ''
        },
        courseList:[],
        // 等待转圈
        dataListLoading: false,
        loading: false,
        isteamPerm: true,
        coursestatusArr: this.enums['courseStatus'] // 课程状态
      }
    },
    props: {
      // teamPerms: { // 权限名称
      //   type: String,
      //   required: true
      // },
      courseInfoList: {
        type: Array,
        required: true
      },
      destinationPlace: {
        type: String,
        required: true
      },
      destinationPlaceId: {
        type: String,
        required: true
      }
    },
    components: {
      catalogtree,
      'subordinate-site': siteSelect,
      offeringCoursedlist,
      'course-multiple': courseSelect
    },
    created () {
      this.mixinViewModuleOptions.getDataListURL = '/learning/base/offeringinfo/page'
      this.mixinViewModuleOptions.getDataListIsPage = true
    },
    activated () {
      this.init()
    },
    methods: {
      // 获取数据列表
      getDataList () {
        let d = new Date()
        // 由于日期区间是2个国际标准的时间字符串显示进行了下面的判断和转换
        if (this.startdateRange === null || this.startdateRange.length === 0) {
          this.dataForm.startTime = ''
        } else {
          // 区间的开始日期默认00:00:00
          d = new Date(this.startdateRange[0])
          let start1 = d.getFullYear() + '-' + this.checkTime((d.getMonth() + 1)) + '-' + this.checkTime(d.getDate()) + ' 00:00:00'
          // 区间的结束日期默认23:59:59
          d = new Date(this.startdateRange[1])
          let start2 = d.getFullYear() + '-' + this.checkTime((d.getMonth() + 1)) + '-' + this.checkTime(d.getDate()) + ' 23:59:59'
          this.dataForm.startTime = start1 + ',' + start2
        }
        if (this.enddateRange === null || this.enddateRange.length === 0) {
          this.dataForm.endTime = ''
        } else {
          d = new Date(this.enddateRange[0])
          let end1 = d.getFullYear() + '-' + this.checkTime((d.getMonth() + 1)) + '-' + this.checkTime(d.getDate()) + ' 00:00:00'
          d = new Date(this.enddateRange[1])
          let end2 = d.getFullYear() + '-' + this.checkTime((d.getMonth() + 1)) + '-' + this.checkTime(d.getDate()) + ' 23:59:59'
          this.dataForm.endTime = end1 + ',' + end2
        }
        // this.dataForm.startTime = new Date()
        console.info('this.dataForm查询的条件----------------->', this.dataForm)
        let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
        console.info('newDataForm---------------------->', newDataForm)
        this.dataListLoading = true
        this.$request.get(
                this.mixinViewModuleOptions.getDataListURL,
                {
                  order: this.order,
                  orderField: this.orderField,
                  page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
                  limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
                  ...newDataForm
                }
        ).then((res, total, code, data) => {
          this.dataListLoading = false
          let resultList = data.data.records
          this.dataList = resultList
          this.total = this.mixinViewModuleOptions.getDataListIsPage ? parseInt(data.data.total, 10) : 0
          // 延迟加载
          this.$nextTick(() => {
            this.querSelect()
          })
        }).catch(() => {
          this.dataListLoading = false
        })
      },
      init () {
        this.resetQuery()
        this.courseData = []
        if (this.courseInfoList && this.courseInfoList.length > 0) {
          this.courseData = this.courseInfoList
        }
        this.dataForm.siteId = this.destinationPlaceId
        this.dataForm.location = this.destinationPlace
        this.dataForm.offeringStatusList = '1'
        this.queryCourse()
      },
      queryCourse () {
        this.page = 1
        this.getDataList()
      },
      checkTime (i) {
        // 这是时间格式化时一位数补充0的处理
        if (i < 10) {
          i = '0' + i
        }
        return i
      },
      showCourseDlg () {
        this.isShowCourse = false
        this.$refs.refCourseMultiple.initSuborSite()
        this.isShowCourse = true
      },
      // 新增时add
      offeringcodeadd: function (data) {
        this.dataForm.courseCode = data.courseCode
        this.dataForm.courseid = data.courseid
        this.dialogTableVisibles = false
      },
      // 选择课程时调用
      offeringcodelist: function (data) {
        console.log(data)
        let ids = []
        let names = []
        let codes = []
        data.forEach(item => {
          ids.push(item.courseid)
          names.push(item.courseName)
          codes.push(item.courseCode)
        })
        this.courseName = names.join(',')
        this.dataForm.courseCode = codes.join(',')
        this.dataForm.courseid = ids.join(',')
      },
      selectCodeClose () {
        this.dialogTableVisibles = false
      },
      onOk: function () {
        let _this = this
        _this.courseList = JSON.parse(JSON.stringify(_this.courseData))
        console.info('_this.courseList------------->', _this.courseList)
        if(_this.courseList <= 0){
          this.$message.warning(this.$t('res.rela.selectCheck'))
          return false
        }
        // 开始时间
        let strDateList = []
        // 结束时间
        let enDateList = []
        if(_this.courseList.length > 0){
          for(let i = 0; i < _this.courseList.length; i++){
            strDateList.push(new Date(_this.courseList[i].startdate.replace(/-/g, '/')).getTime())
            console.info(i,'-------------------->',new Date(_this.courseList[i].startdate.replace(/-/g, '/')).getTime())
            enDateList.push(new Date(_this.courseList[i].enddate.replace(/-/g, '/')).getTime())
            console.info(i,'-------------------->',new Date(_this.courseList[i].enddate.replace(/-/g, '/')).getTime())
          }
        }
        // 开始时间从小到大排序
        let strDateListS = []
        for (let i = 0; i < strDateList.length; i++) {
          for (var j = 0; j < strDateList.length -i - 1; j ++) {
            if (strDateList[j] > strDateList[j+1]) {  // 相邻元素两对比
              strDateListS = strDateList [j+1];
              strDateList[j+1]= strDateList [j];
              strDateList[j] = strDateListS;
            }
          }
        }
        console.info('strDateList-------------->', strDateList)
        // 结束时间从小到大排序
        let enDateListS = []
        for (let i = 0; i < enDateList.length; i++) {
          for (var j = 0; j < enDateList.length -i - 1; j ++) {
            if (enDateList[j] > enDateList[j+1]) {  // 相邻元素两对比
              enDateListS = enDateList [j+1];
              enDateList[j+1]= enDateList [j];
              enDateList[j] = enDateListS;
            }
          }
        }
        console.info('enDateList-------------->', enDateList)
        // 取最早的排期开始时间
        console.info('最早的开始时间------------------->', new Date(strDateList[0]))
        console.info('最晚的结束时间------------------->', new Date(enDateList[enDateList.length - 1]))
        _this.$emit('couronOk', _this.courseList,new Date(strDateList[0]),new Date(enDateList[enDateList.length - 1]))
        // _this.$refs.coursePlanTable.clearSelection()
      },
      cancel: function(){
        this.$emit('cancel')
      },
      // 课程分类调用树
      cateloglist: function (data) {
        let catalogId = ''
        let catalogNameCn = ''
        data[0].data.forEach(rows => {
          catalogId = catalogId + rows.catalogId + ','
          catalogNameCn = catalogNameCn + rows.catalogNameCn + ','
        })
        // this.$message(catalogId)
        this.dataForm.catalogId = catalogId
        // this.$message(catalogId)
      },
      // 单选
      selectRedio: function selectRedio (selection, row) {
        let flag = true
        let yesOrNo = true
         for(let a = 0; a < this.courseData.length; a++){
           if(row.offeringNo === this.courseData[a].offeringNo){
             yesOrNo = false
             break
           }
         }
         if(yesOrNo){
          for (let i = 0; i < this.courseData.length; i++) {
            // 小于
            console.info('new Date(row.enddate)------------------>', new Date(row.enddate))
            console.info('new Date(this.courseData[i].startdate)------------------>', new Date(this.courseData[i].startdate))
            console.info('new Date(row.startdate)------------------>', new Date(row.startdate))
            console.info('new Date(this.courseData[i].enddate)------------------>', new Date(this.courseData[i].enddate))
            if (!(new Date(row.enddate.replace(/-/g, '/')) < new Date(this.courseData[i].startdate.replace(/-/g, '/')) || new Date(row.startdate.replace(/-/g, '/')) > new Date(this.courseData[i].enddate.replace(/-/g, '/')))) {
              flag = false
            }
          }
         }
        if (flag) {
          let result = []
          for (let a = 0; a < selection.length; a++) {
            if (row.offeringNo === selection[a].offeringNo) {
              result.push(row)
              break
            }
          }
          if (result.length > 0) {
            if (this.isSelectElection && this.$refs.coursePlanTable.selection.length > 1) {
              this.$refs.coursePlanTable.clearSelection()// 清空
              this.courseData = []
              this.courseData.push(row)
              this.$refs.coursePlanTable.toggleRowSelection(row)// 选择当前行
            } else {
              if (row) {
                this.courseData.push(row)
                // row.courseData = row.courseData
              }
            }
          } else {
            if (this.isSelectElection && this.$refs.coursePlanTable.selection.length > 1) {
              this.$refs.coursePlanTable.clearSelection()// 清空
              this.courseData = []
            } else {
              for (let b = 0; b < this.courseData.length; b++) {
                if (row.offeringNo === this.courseData[b].offeringNo) {
                  this.courseData.splice(b, 1)
                  break
                }
              }
            }
          }
         }else{
          selection.splice(selection.length - 1, 1)
          this.$message({
            message: '该时间区间有重叠,请重新选择!',
            type: 'error',
            duration: 2000
          })
        }
      },
      selectionChange(selection){
        console.info('selection---------------->', selection)
      },
      // 控制可选项
      // checkboxT (row, index) {
      //   let _this = this
      //   let checkFlg = 1
      //   if ( _this.courseInfoList && _this.courseInfoList.length > 0) {
      //     _this.courseInfoList.forEach(function (item) {
      //       if (row.courseCode === item.courseCode) {
      //         checkFlg = 0
      //       }
      //     })
      //   }
      //   return checkFlg
      // },
      // 全选
      // selectAllRedio (selection) {
      //   let _this = this
      //   if (selection) {
      //     let courseDataB = []
      //     if (_this.courseData && _this.courseData.length > 0) {
      //       _this.courseData.forEach(function (item) {
      //         courseDataB.push(item)
      //       })
      //     }
      //     if (selection.length > 0) {
      //       for (var i = 0; i < selection.length; i++) {
      //         let hasFlg = false
      //         if (courseDataB && courseDataB.length > 0) {
      //           for (var l = 0; l < courseDataB.length; l++) {
      //             if (courseDataB[l].courseCode === selection[i].courseCode) {
      //               hasFlg = true
      //             }
      //           }
      //         }
      //         if (!hasFlg) {
      //           _this.courseData.push(selection[i])
      //         }
      //       }
      //     } else {
      //       _this.courseData = []
      //       if (courseDataB && courseDataB.length > 0) {
      //         for (var j = 0; j < courseDataB.length; j++) {
      //           let hasFlg = false
      //           for (var k = 0; k < _this.dataList.length; k++) {
      //             if (courseDataB[j].courseCode === _this.dataList[k].courseCode) {
      //               hasFlg = true
      //             }
      //           }
      //           if (!hasFlg) {
      //             _this.courseData.push(courseDataB[j])
      //           }
      //         }
      //       }
      //     }
      //   }
      // },
      // 删除已选备件
      handleClose (data) {
        for (let a = 0; a < this.dataList.length; a++) {
          if (data.courseCode === this.dataList[a].courseCode) {
            this.$refs.coursePlanTable.toggleRowSelection(this.dataList[a], false)// 选择当前行
            break
          }
        }
        this.courseData.splice(this.courseData.indexOf(data), 1)
      },
      // 打开页面时，回填勾选
      querSelect () {
        if (this.courseData && this.courseData.length > 0) {
          var map = new Map()
          this.courseData.forEach(function (item, index) {
            map.set(String(item.offeringNo), item)
          })
          let _this = this
          _this.dataList.forEach(function (dataitem, dataindex) {
            if (map.has(String(dataitem.offeringNo))) {
              _this.$refs.coursePlanTable.toggleRowSelection(dataitem)
            }
          })
        }
      },
      // toggleSelection (rows) {
      //   debugger
      //   var chexcksss = this.$refs.coursePlanTable.selection// 得到选中的值
      //   chexcksss.forEach(row => {
      //     this.datalist.push({ id: row.courseId, courseKind: row.courseKind, course: row.courseCode + '-' + row.courseNameCn })
      //   })
      //   this.$emit('couronOk', this.datalist)
      //   this.datalist = []
      // },
      coursestatusformat (row) {
        return Vue.filter('coverEnum')(row.courseStatus, 'courseStatus')
      },
      courseDaysformat (row, column, cellValue) {
        if (cellValue) {
          return cellValue.toFixed(2)
        }
      },
      // 重置查询条件
      resetQuery () {
        // this.$refs.catalogtree.resetChecked()
        this.selectTable = []
        this.selectCourseTable = []
        this.dataForm = {
          offeringNo: '',
          offeringName: '',
          offringstatus: '',
          catalogId: '', // 课程分类
          courseTeamCatalogFirst: '',
          courseTeamCatalogSecond: '', // 课程团队分类
          courseid: [],
          regionIds: [],
          courseCode: [],
          courselabel: '', // 课程标签
          startTime: '',
          endTime: ''
        }
        this.courseName = ''
        this.startdateRange = []
        this.enddateRange = []
        this.loading = false
        try {
          this.$refs.offeringCoursedlist.toggleSelection()
        } catch (e) {

        }
      },
      GetcourseTeamCatalog (prov) {
        let tempArry = []
        this.select2 = []
        if (this.dataForm.selectCatalogSecond !== null || this.dataForm.selectCatalogSecond === '') {
          this.dataForm.selectCatalogSecond = ''
        }
        for (var val of this.allteamcatalog) {
          var code = val.code.slice(0, 2)
          if (prov === code) {
            tempArry.push({ name: val.name, code: val.code })
          }
          this.select2 = tempArry
        }
      },
      demandformat (row, column, cellValue) {
        if (cellValue === '10') {
          return '未发布'
        } else if (cellValue === '20') {
          return '已发布'
        } else if (cellValue === '30') {
          return '已取消'
        } else if (cellValue === '40') {
          return '已关课'
        } else {
          return ' '
        }
      },
      closeCourseDlg () {
        console.log('closeCOurseDlg')
        console.log(this.isShowCourse)
        this.isShowCourse = false
        console.log(this.isShowCourse)
      },
      resetCourseData () {
        this.selectCourseTable = []
        this.courseName = ''
      },
      courseSelectBack (selection) {
        console.log(selection)
        console.log(selection)
        let ids = []
        let names = []
        let codes = []
        selection.forEach(item => {
          ids.push(item.courseId)
          names.push(item.courseNameCn)
          codes.push(item.courseCode)
        })
        this.courseName = names.join('/')
        this.dataForm.courseCode = codes.join(',')
        this.dataForm.courseid = ids.join(',')
        this.selectCourseTable = selection
        this.isShowCourse = false
        this.closeCourseDlg()
      },
      closeSuboSiteDlg () {
        this.isShowSuboSite = false
      },
      bringBack (selection) {
        console.log(selection)
        let siteNames = []
        let siteIds = []
        let siteClassNameCns = []
        let cityNames = []
        let cityIds = []
        let siteCodes = []
        selection.forEach(item => {
          siteNames.push(item.siteCnName)
          siteIds.push(item.id)
          siteClassNameCns.push(item.siteClassCnName)
          cityNames.push(item.cityName)
          cityIds.push(item.cityId)
          siteCodes.push(item.siteNo)
        })
        console.log(this.dataForm)
        this.dataForm.siteId = siteIds.join(',')
        this.dataForm.location = siteNames.join('/')
        this.isShowSuboSite = false
        this.selectTable = selection
        this.closeSuboSiteDlg()
      },
      showSuboSiteDlg () {
        this.isShowCourse = false
        this.isShowSuboSite = false
        this.$refs.suborSiteRef.initSuborSite()
        this.isShowSuboSite = true
      }
    }
  }
</script>
<style scoped>
  .el-row {
    margin-bottom: 0px;
  }

  .el-form .el-row:first-child .el-col:nth-child(3) {
    padding-left: 20px;
  }

</style>
<style>
  .curriculum-search-condition .el-form-item__content {
    margin-left: 96px !important;
  }
</style>
<style>
  /* 隐藏网格的全选按钮 */
  .jySelectionAll
  > .el-table__header-wrapper
  > .el-table__header
  > thead
  > tr
  > th
  > .cell
  > label {
    display: none !important;
  }
  .selectRadioClass thead .el-table-column--selection .cell {
    display: none !important;
  }
</style>
